// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l8bMW","content":"styles_content__3eGJ2"};